import { createSelector } from 'reselect';
import {
  getMealExchangeActiveDay,
  getMealExchangeDays,
  getSelectedDays,
  getSelectedMeals,
} from '@redux/selectors/orderFormSelector';
import { DateTime } from 'luxon';

export const getDeliveryMealCounts = createSelector(
  [getSelectedDays, getMealExchangeDays, getSelectedMeals],
  (
    selectedDays: Array<number>,
    mealExchangeDays: Record<string, { mealsList: any }>,
    selectedMeals: Array<{ selected: boolean }>
  ) =>
    selectedDays.reduce((acc: Record<string, number>, curr: number) => {
      const isoDate = DateTime.fromMillis(curr).toISODate() || '';
      const customDeliveryMealsDate = mealExchangeDays[isoDate];

      acc[isoDate] = customDeliveryMealsDate
        ? Object.keys(customDeliveryMealsDate.mealsList || {}).length
        : selectedMeals.filter(boolValue => boolValue.selected).length;

      return acc;
    }, {})
);

export const getMenuConfSelectedMealsAmountPerDay = createSelector(
  [getMealExchangeDays, getMealExchangeActiveDay],
  (mealExchangeDays, activeDay) => {
    if (
      Object.keys(mealExchangeDays).length === 0 ||
      !(activeDay in mealExchangeDays)
    ) {
      return 0;
    }
    return Object.keys(mealExchangeDays[activeDay].mealsList || {}).length;
  }
);
